export enum RubricResponse {
    INAPPLICABLE = -2,
    UNSELECTED = -1,
    FAILING = 1,
    NEEDS_IMPROVEMENT = 2,
    PROFICIENT = 3,
    EXCEEDS_EXPECTATION = 4
}